import React, { useState, useRef, useEffect } from 'react';
import { Button, Form, Modal, Spinner } from 'react-bootstrap';
import { useToggle } from '../../../hooks';
import { destroy, post, put } from '../../../utils/DeApi';
import ErrorHandler from '../../ErrorHandler/ErrorHandler';
import { getToken } from "../../../utils/AuthService"
import { useLocation } from "react-router-dom";

const KeywordTypeModal = ({
    mode = 'Add',
    keyType = {},
    onClose = () => null,
    show = false,
    userAction = () => null,
    setAlertShow = () => false,
    user = {}
}) => {

    const [name, setName] = useState(keyType?.name || '');
    const [isSubmitting, toggleIsSubmitting] = useToggle(false);
    const [error, setError] = useState(null);
    const subscribedPromises = useRef([]);
    const { pathname } = useLocation();
    const pgmUser = getToken("is_pgm_user") || "n";
    const isPgmUser = pgmUser === "y" && pathname.startsWith("/leadsmodule")

    useEffect(() => {
        if (keyType?.name) {
            setName(keyType.name);
        }
    }, [keyType]);

    useEffect(() => {
        const promises = subscribedPromises.current;
        return () => { promises.forEach((cancel) => cancel()) };
    }, []);

    if (mode === "Delete") {
        return (<DeleteKeywordTypeContent show={show} keywordType={keyType} onClose={onClose} isPgmUser={isPgmUser} />);
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        toggleIsSubmitting();
        const { promise, cancel } = mode === 'Add'
            ? isPgmUser
                ? post('keywordtypesTraining', { name, email: user?.email, is_lock: 0 })
                : post('keywordtypes', { name })
            : isPgmUser
                ? put(`keywordtypesTraining/${keyType?.id}`, { name, email: user?.email, is_lock: 0 })
                : put(`keywordtypes/${keyType?.id}`, { name })
        /* *** subscribing promise *** */
        promise.then((response) => {
            setName('');
            console.log("mode = " + mode + " post has", response)
            if (mode === 'Add') {
                userAction(response);
            } else {
                userAction([]);
            }
            setAlertShow(true);
            onClose(response.data, mode);
        }).catch((error) => setError(error)).finally(toggleIsSubmitting);
        /* *** keeping used promise instance *** */
        subscribedPromises.current.push(cancel);
    }
    return (
        <Modal show={show} onHide={() => { onClose(); setError(null); }} centered>
            <Modal.Header closeButton>
                <Modal.Title className='color-deal-style'>{mode} Keyword Type</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    <Form.Group className='mb-3' controlId='formBasicEmail'>
                        <Form.Label>Keyword Name</Form.Label>
                        <Form.Control type='text' className='roundedEdges' value={name} placeholder='Enter Keyword Type' onChange={e => setName(e.target.value)} />
                    </Form.Group>
                    <Button type='submit' className='float-right btn btn-success-deal-style roundedEdges' disabled={isSubmitting}>
                        {isSubmitting && (<Spinner as='span' animation='border' className='mb-1' variant='light' size='sm' />)} {mode}
                    </Button>
                </Form>
                {/* Error Handling ( Below ) */}
                {error && <ErrorHandler error={error} />}
            </Modal.Body>
        </Modal>
    )
}


const DeleteKeywordTypeContent = ({ keywordType, onClose, show, isPgmUser }) => {
    const [isSubmitting, toggleIsSubmitting] = useToggle(false);
    const [error, setError] = useState(null);
    const subscribedPromises = useRef([]);

    const handleDelet = () => {
        toggleIsSubmitting();
        const { promise, cancel } = isPgmUser ? destroy(`keywordtypesTraining/${keywordType.id}`) : destroy(`keywordtypes/${keywordType.id}`);
        promise.then((response) => onClose(keywordType))
            .catch((error) => setError(error))
            .finally(toggleIsSubmitting);
        subscribedPromises.current.push(cancel);
    }

    useEffect(() => {
        const promises = subscribedPromises.current;
        return () => promises.forEach((cancel) => cancel())
    }, []);

    /* *** returning content ( below ) *** */
    return (
        <Modal show={show} onHide={() => { onClose(); setError(); }} centered backdrop='static'>
            <Modal.Header closeButton>
                <Modal.Title className='color-deal-style'>Delete Keyword Type</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Are you sure you want to delete <span className='font-font-weight-bold text-danger'>{keywordType?.name}</span>?
                {error && <ErrorHandler error={error} />}
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant='danger'
                    onClick={handleDelet}
                    className="roundedEdges"
                    disabled={isSubmitting}>
                    {isSubmitting && <Spinner as='span' animation='border' variant='light' size='sm' className='m-1' />} Yes, Delete
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
export default KeywordTypeModal;